import React, { useState } from "react";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, FormControlLabel, FormGroup, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const WhoCompletedThisSurveyView = ({ open, onClose, onSubmit} : {open: boolean, onClose: () => void, onSubmit: (values: string[]) => void}) => {
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const { t } = useTranslation('generic');

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedValues(prevValues =>
      event.target.checked
        ? [...prevValues, value]
        : prevValues.filter(v => v !== value)
    );
  };

  const handleSubmit = () => {
    onSubmit(selectedValues);
    onClose();
  };

  return (
    <Dialog open={open}>
      <DialogContent>
        <Typography>
          {t("Who helped you answer the questions today? For example, did someone help you remember your medication list or how tired you are? This isn't the person who helps you understand the question, but the one who helps you provide the answers.")}
          {' '}
          {t("Select all that apply")}
        </Typography>

        <FormGroup>
          <FormControlLabel control={<Checkbox value="justMe" onChange={handleCheckboxChange} />} label={t("Just me")} />
          <FormControlLabel control={<Checkbox value="someoneElse" onChange={handleCheckboxChange} />} label={t("Someone else helped me answer the questions")} />
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" autoFocus onClick={handleSubmit} disabled={selectedValues.length === 0}>
          {t("Submit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WhoCompletedThisSurveyView;
